<div
  [ngClass]="{ 'standalone-mode modal-content': isStandaloneMode }"
  class="organization-modal"
  [attr.piqetAngularDraggable]="!isStandaloneMode ? '' : null"
>
  <div class="modal-header" *ngIf="!isStandaloneMode">
    <h2 class="modal-title ml-auto pl-5">
      <div class="bootstrap-dialog-title">User Signup Details</div>
    </h2>
    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" alt="Close button" />
    </button>
  </div>

  <div class="modal-body">
    <div class="bootstrap-dialog-body">
      <div class="user-details-container">
        <!-- Organization Information -->
        <div class="detail-section">
          <h5 class="section-title">Organization information</h5>
          <div class="table-form">
            <div class="table-row">
              <div class="table-cell label-cell">Organization name:</div>
              <div class="table-cell value-cell">
                {{ userDetails?.organisationName || userDetails?.organizationName || '-' }}
              </div>
            </div>
            <div class="table-row">
              <div class="table-cell label-cell">Country:</div>
              <div class="table-cell value-cell">
                {{ data?.countryName || '-' }}
              </div>
            </div>
            <div class="table-row">
              <div class="table-cell label-cell">Address:</div>
              <div class="table-cell value-cell">
                {{ userDetails?.address || '-' }}
              </div>
            </div>
          </div>
        </div>

        <!-- User Information -->
        <div class="detail-section">
          <h5 class="section-title">User information</h5>
          <div class="table-form">
            <div class="table-row">
              <div class="table-cell label-cell">First name:</div>
              <div class="table-cell value-cell">
                {{ userDetails?.firstname || '-' }}
              </div>
            </div>
            <div class="table-row">
              <div class="table-cell label-cell">Last name:</div>
              <div class="table-cell value-cell">
                {{ userDetails?.lastname || '-' }}
              </div>
            </div>
            <div class="table-row">
              <div class="table-cell label-cell">Email:</div>
              <div class="table-cell value-cell">
                {{ userDetails?.userName || userDetails?.email || '-' }}
              </div>
            </div>
          </div>
        </div>

        <!-- Verification Status -->
        <div class="detail-section">
          <h5 class="section-title">Verification status</h5>
          <div class="table-form">
            <div class="table-row">
              <div class="table-cell label-cell">Email verified:</div>
              <div class="table-cell value-cell">
                {{ data?.isEmailVerified ? 'Yes' : 'No' }}
              </div>
            </div>
            <div class="table-row">
              <div class="table-cell label-cell">Logo consent:</div>
              <div class="table-cell value-cell">
                {{ userDetails?.logoConsent ? 'Yes' : 'No' }}
              </div>
            </div>
            <div class="table-row">
              <div class="table-cell label-cell">Terms agreed:</div>
              <div class="table-cell value-cell">
                {{ userDetails?.isAgree ? 'Yes' : 'No' }}
              </div>
            </div>
          </div>
        </div>

        <!-- Approval Status & Dates -->
        <div class="detail-section">
          <h5 class="section-title">Approval information</h5>
          <div class="table-form">
            <div class="table-row">
              <div class="table-cell label-cell">Current status:</div>
              <div class="table-cell value-cell">
                {{ data?.statusString || 'Pending' }}
              </div>
            </div>
            <div class="table-row">
              <div class="table-cell label-cell">Requested on:</div>
              <div class="table-cell value-cell">
                {{ data?.requestedOn ? data.requestedOn + ' UTC' : '-' }}
              </div>
            </div>
            <div class="table-row">
              <div class="table-cell label-cell">Updated on:</div>
              <div class="table-cell value-cell">
                {{ data?.updatedOn ? data.updatedOn + ' UTC' : '-' }}
              </div>
            </div>
          </div>
        </div>

        <div class="detail-section status-update-section">
          <h5 class="section-title">Update status</h5>
          <form [formGroup]="commentForm">
            <div class="table-form">
              <div class="table-row">
                <div class="table-cell label-cell">Update current status:</div>
                <div class="table-cell value-cell">
                  <div class="form-group required">
                    <div class="project-spacing selctstops02">
                      <ng-select
                        [items]="statusOptions"
                        bindLabel="name"
                        bindValue="id"
                        [(ngModel)]="selectedStatus"
                        [ngModelOptions]="{ standalone: true }"
                        (change)="onStatusChange($event)"
                        placeholder="Select status"
                        [clearable]="false"
                        class="custom-ng-select"
                      >
                        <ng-template ng-header-tmp>
                          <div class="has-feedback">
                            <input
                              type="text"
                              class="form-control accordion-search search-input"
                              id="inputValidation"
                              placeholder="Search..."
                              (input)="statusOptions.filter($any($event.target).value)"
                            />
                            <span class="form-control-feedback">
                              <i class="fa fa-search icon"></i>
                            </span>
                          </div>
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                          <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                            {{ item.name }}
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Comment Box (shown only when Rejected is selected) -->
              <div class="table-row" *ngIf="showCommentBox">
                <div class="table-cell label-cell">Reason:</div>
                <div class="table-cell value-cell">
                  <div disabledStyle="blur" class="form-group">
                    <label
                      *ngIf="commentForm.controls['comment']?.value"
                      class="sub-header-drpdown pb-2"
                      >Reason should be only 500 characters.</label
                    >
                    <div class="services-form">
                      <textarea
                        formControlName="comment"
                        class="resizable-textarea"
                        cols="20"
                        id="Description"
                        name="Description"
                        rows="4"
                        maxlength="500"
                        placeholder="Comment"
                      ></textarea>
                      <label *ngIf="!commentForm.controls['comment']?.value">Reason</label>
                    </div>
                    <div
                      *ngIf="
                        commentForm.controls['comment']?.touched &&
                        commentForm.controls['comment']?.invalid
                      "
                    >
                      <div
                        class="input-error"
                        *ngIf="commentForm.controls['comment']?.errors?.['required']"
                      >
                        Reason is required.
                      </div>
                      <div
                        class="input-error"
                        *ngIf="commentForm.controls['comment']?.errors?.['maxlength']"
                      >
                        Reason cannot exceed
                        {{ commentForm.controls['comment'].errors?.['maxlength']?.requiredLength }}
                        characters.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="table-row" *ngIf="data?.comment">
                <div class="table-cell label-cell">Reason:</div>
                <div class="table-cell value-cell">
                  {{ data?.comment }}
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="alert alert-warning" role="alert">
          <strong>Note:</strong> Updating the status will automatically send an email notification
          to the requested user.
        </div>
      </div>

      <div class="setButtonAndError box-footer">
        <div class="modal-footer">
          <button type="button" class="cancelBtn" (click)="onClose()">Close</button>
          <button
            type="button"
            class="modelBtn purpleBtnHoverEffect"
            (click)="onUpdate()"
            [disabled]="!commentForm.valid"
          >
            {{ buttonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
